import type { RootState } from "src/store";

export const selectAvatar = (state: RootState) => {
  return state.avatar;
};
